<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Daftar Kontrak</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/notaris">
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Kontrak</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <b-tabs justified @input="onChangeTab">
          <b-tab active title="Fiducia">
            <CRow class="mt-3">
              <CCol class="col-xs-12 ml-5">
                <b-input-group>
                  <b-input-group-prepend>
                    <!-- <b-form-select v-model="filter.value" :options="filter.options" disabled></b-form-select> -->
                    <multiselect 
                      v-model="filter.value" 
                      :options="filter.options" 
                      class="mb-0 filter-option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      :disabled="true"
                    >
                    </multiselect>
                  </b-input-group-prepend>
                  <b-input-group-append>
                    <multiselect 
                      v-model="filter.officeFiducia" 
                      :options="officeData.options" 
                      class="mb-0"
                      placeholder="Filter Office"
                      :showLabels="false"
                      openDirection="bottom"
                      label="nameFull"
                      track-by="officeCode"
                      :internalSearch="false"
                      :preserveSearch="false"
                      @search-change="populateOffice"
                      @input="getAssignContractFiduciaTableItems"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="officeData.currentPage < officeData.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="officeData.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-input-group-append>
                </b-input-group>
              </CCol>
            </CRow>
            <CRow class="mt-4">
              <CCol>
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="contractFiduciaTable.items"
                  :fields="contractFiduciaTable.fields"
                  :busy="!contractFiduciaTable.isLoaded"
                  no-local-sorting no-sort-reset
                  @sort-changed="onContractFiduciaTableSortChanged"
                >
                  <template #cell(no)="row">
                    {{ $helper.showData(row.index+1, "string") }}.
                  </template>
                  <template #cell(bussUnit)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(contractType)="row">
                      <CBadge v-if="row.value == 'F'" color="secondary"> FIDUCIA
                      </CBadge>
                      <CBadge v-else-if="row.value == 'R'" color="secondary"> ROYA
                      </CBadge>
                      <CBadge v-else color="secondary"> -
                      </CBadge>
                  </template>
                  <template #cell(officeName)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(custType)="row">
                      <CBadge v-if="row.value == 'I'" color="secondary"> INDIVIDU
                      </CBadge>
                      <CBadge v-else-if="row.value == 'C'" color="secondary"> COMPANY
                      </CBadge>
                      <CBadge v-else color="secondary"> -
                      </CBadge>
                  </template>
                  <template #cell(countContract)="row">
                    {{ $helper.showData(row.value, "number") }}
                  </template>
                  <template #cell(action)="row">
                    <CButton size="sm" color="success" class="custom-button-action" style="width:5.5rem" @click="$router.push({ name: 'Assign Contract Fiducia', params: { contractParams: row.item.custType + row.item.contractType + row.item.officeCode + '-' + row.item.bussUnit } })">
                      Assign
                    </CButton>
                  </template>
                  <template slot="empty">
                    <div v-if="!contractFiduciaTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="contractFiduciaTable.totalRows" :page="contractFiduciaTable.currentPage" @page-change="onContractFiduciaTablePageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
          </b-tab>
          <b-tab title="Roya">
            <CRow class="mt-3">
              <CCol class="col-xs-12 ml-5">
                <b-input-group>
                  <b-input-group-prepend>
                    <!-- <b-form-select v-model="filter.value" :options="filter.options" disabled></b-form-select> -->
                    <multiselect 
                      v-model="filter.value" 
                      :options="filter.options" 
                      class="mb-0 filter-option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      :disabled="true"
                    >
                    </multiselect>
                  </b-input-group-prepend>
                  <b-input-group-append>
                    <multiselect 
                      v-model="filter.officeRoya" 
                      :options="officeData.options" 
                      class="mb-0"
                      placeholder="Filter Office"
                      :showLabels="false"
                      openDirection="bottom"
                      label="nameFull"
                      track-by="officeCode"
                      :internalSearch="false"
                      :preserveSearch="false"
                      @search-change="populateOffice"
                      @input="getAssignContractRoyaTableItems"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="officeData.currentPage < officeData.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="officeData.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-input-group-append>
                </b-input-group>
              </CCol>
            </CRow>
            <CRow class="mt-4">
              <CCol>
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="contractRoyaTable.items"
                  :fields="contractRoyaTable.fields"
                  :busy="!contractRoyaTable.isLoaded"
                  no-local-sorting no-sort-reset
                  @sort-changed="onContractRoyaTableSortChanged"
                >
                  <template #cell(no)="row">
                    {{ $helper.showData(row.index+1, "string") }}.
                  </template>
                  <template #cell(bussUnit)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(contractType)="row">
                      <CBadge v-if="row.value == 'F'" color="secondary"> FIDUCIA
                      </CBadge>
                      <CBadge v-else-if="row.value == 'R'" color="secondary"> ROYA
                      </CBadge>
                      <CBadge v-else color="secondary"> -
                      </CBadge>
                  </template>
                  <template #cell(officeName)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(custType)="row">
                      <CBadge v-if="row.value == 'I'" color="secondary"> INDIVIDU
                      </CBadge>
                      <CBadge v-else-if="row.value == 'C'" color="secondary"> COMPANY
                      </CBadge>
                      <CBadge v-else color="secondary"> -
                      </CBadge>
                  </template>
                  <template #cell(countContract)="row">
                    {{ $helper.showData(row.value, "number") }}
                  </template>
                  <template #cell(action)="row">
                    <CButton size="sm" color="success" class="custom-button-action" style="width:5.5rem" @click="$router.push({ name: 'Assign Contract Roya', params: { contractParams: row.item.custType + row.item.contractType + row.item.officeCode + '-' + row.item.bussUnit } })">
                      Assign
                    </CButton>
                  </template>
                  <template slot="empty">
                    <div v-if="!contractRoyaTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="contractRoyaTable.totalRows" :page="contractRoyaTable.currentPage" @page-change="onContractRoyaTablePageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
          </b-tab>
        </b-tabs>
      </CCardBody>
    </CCard>
  </CContainer>
</template>


<script>
export default {
  name: 'AssignContractList',
  data() {
    return {
      officeData: {
        isLoaded: false,
        isValid: null,
        isRequired: true,
        options: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0,
        lastQuery: '',
      },
      filter: {
        value: { value:"office", text: "Office" },
        options: [
          { value:"office", text: "Office" },
        ],
        officeFiducia: null,
        officeRoya: null,
      },
      contractFiduciaTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "no", label: "No.", sortable: false},
          {key: "bussUnit", label: "Business Unit", sortable: false},
          {key: "contractType", label: "Tipe Kontrak", sortable: false},
          {key: "officeCode", label: "Kode Office", sortable: false},
          {key: "officeName", label: "Nama Office", sortable: false},
          {key: "custType", label: "Tipe Customer", sortable: false},
          {key: "countContract", label: "Jumlah Kontrak", sortable: false},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      contractRoyaTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "no", label: "No.", sortable: false},
          {key: "bussUnit", label: "Business Unit", sortable: false},
          {key: "contractType", label: "Tipe Kontrak", sortable: false},
          {key: "officeName", label: "Nama Office", sortable: false},
          {key: "custType", label: "Tipe Customer", sortable: false},
          {key: "countContract", label: "Jumlah Kontrak", sortable: false},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {
    onContractFiduciaTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getAssignContractFiduciaTableItems(newPage)
    },
    onContractRoyaTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getAssignContractRoyaTableItems(newPage)
    },
    onContractFiduciaTableSortChanged(ctx) {
      this.contractFiduciaTable.sortBy = ctx.sortBy
      this.contractFiduciaTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getAssignContractFiduciaTableItems(this.contractFiduciaTable.currentPage)
    },
    onContractRoyaTableSortChanged(ctx) {
      this.contractRoyaTable.sortBy = ctx.sortBy
      this.contractRoyaTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getAssignContractRoyaTableItems(this.contractRoyaTable.currentPage)
    },
    // get paginated table contents from server-side
    getAssignContractFiduciaTableItems(page = 1) {
      if(isNaN(page)) {
        this.contractFiduciaTable.currentPage = 1
      }
      else if(this.$helper.isEmpty(page)){
        this.contractFiduciaTable.currentPage = 1
      }
      else {
        this.contractFiduciaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/fiducia/getContractCountAndData"
      let params = {}
      params['page'] = (this.contractFiduciaTable.currentPage - 1)
      params['size'] = this.contractFiduciaTable.perPage
      if(!this.$helper.isEmpty(this.filter.officeFiducia)){
        params['officeCode'] = this.filter.officeFiducia.officeCode
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.contractFiduciaTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.contractFiduciaTable.items = response.data.data.data.map(item => {
              return {
                "bussUnit": item.bussUnit,
                "contractType": item.contractType,
                "officeCode": item.officeCode,
                "officeName": item.officeName,
                "custType": item.custType,
                "countContract": item.countContract
              }
            })
            this.contractFiduciaTable.totalRows = response.data.data.totalElements
            this.contractFiduciaTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractFiduciaTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    getAssignContractRoyaTableItems(page = 1) {
      if(isNaN(page)) {
        this.contractRoyaTable.currentPage = 1
      }
      else if(this.$helper.isEmpty(page)){
        this.contractRoyaTable.currentPage = 1
      }
      else {
        this.contractRoyaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/roya/getContractCountAndData"
      let params = {}
      params['page'] = (this.contractRoyaTable.currentPage - 1)
      params['size'] = this.contractRoyaTable.perPage
      if(!this.$helper.isEmpty(this.filter.officeRoya)){
        params['officeCode'] = this.filter.officeRoya.officeCode
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.contractRoyaTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.contractRoyaTable.items = response.data.data.data.map(item => {
              return {
                "bussUnit": item.bussUnit,
                "contractType": item.contractType,
                "officeCode": item.officeCode,
                "officeName": item.officeName,
                "custType": item.custType,
                "countContract": item.countContract
              }
            })
            this.contractRoyaTable.totalRows = response.data.data.totalElements
            this.contractRoyaTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Assign Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.contractRoyaTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    populateOffice(query = "") {
      this.officeData.isLoaded = false
      this.officeData.totalPages = 0
      this.officeData.totalRows = 0
      this.officeData.currentPage = 1
      this.officeData.lastQuery = query
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.officeData.currentPage - 1, this.officeData.perPage)
      if(query !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = query
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.officeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.officeData.options.push(response.data.data.data[i])
            }
            this.officeData.totalRows = response.data.data.totalElements
            this.officeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.officeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendSelectOffice() {
      this.officeData.isLoaded = false
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.officeData.currentPage, this.officeData.perPage)
      if(this.officeData.lastQuery !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = this.officeData.lastQuery
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.officeData.options.push(response.data.data.data[i])
            }
            this.officeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.officeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    onChangeTab() {
      this.populateOffice()
    }
  },
  computed: {
  },
  mounted() {
    // get table contents on page load
    this.getAssignContractFiduciaTableItems()
    this.getAssignContractRoyaTableItems()
    this.populateOffice()
  },
  created() {
  }
}
</script>

<style>

</style>
